import SubVisual from '@/components/SubVisual';
import { Outlet } from 'react-router';
import PolicySelectBox from '@/pages/policy/components/PolicySelectBox';
import { privacyTab } from '@/pages/policy/constants';
import { usePrivacyPage } from './privacy/hook/usePrivacy';

const PrivacyPage = () => {
	const { activeTab, dateList, tosContent, handleTabChange, handleDateChange } = usePrivacyPage();

	return (
		<main id="privacy" className={`sub terms privacy`}>
			<SubVisual
				title={privacyTab.subTab[activeTab].title}
				subTab={privacyTab.subTab}
				currTabIndex={activeTab}
				cate={''}
				onChangeTab={handleTabChange}
			/>
			<section className="sub-content">
				<div className="sub-inner">
					<PolicySelectBox selectItems={dateList} onChangeSelect={handleDateChange} />
					<Outlet context={tosContent} />
				</div>
			</section>
		</main>
	);
};

export default PrivacyPage;
